import React, { useCallback } from "react";
import { useDispatch } from "react-redux";
import { AppAlert } from "../../../../components/dialogue/Dialogue";
import { useAppSelector } from "../../../../redux/hooks";
import { Container } from "../../../../globalstyled";
import AppLoader from "../../../../components/loader";
import SuppliersTable from "./SuppliersTable";
import { useFetchSuppliers } from "../../../../apolloClient/hooks/itemCreation/fetchHooks";

interface SuppliersProps {
  permissions: boolean;
}

const Suppliers: React.FC<SuppliersProps> = ({ permissions }) => {
  const dispatch = useDispatch();

  const userReducer = useAppSelector((state) => state.userReducer);
  // You can add suppliers to the reducer if needed

  const {
    loading,
    error,
    suppliers,
    refetch,
  } = useFetchSuppliers({
    limit: 100,
    offSet: 0,
  });

  const handleRefetch = useCallback(() => {
    refetch();
  }, [refetch]);

  if (loading) return <AppLoader />;

  return (
    <Container>
      <SuppliersTable suppliersData={suppliers} refetchSuppliers={handleRefetch} permissions={permissions} />
    </Container>
  );
};

export default Suppliers;
